import { render, staticRenderFns } from "./IframeResize.vue?vue&type=template&id=bbaee156&"
import script from "./IframeResize.vue?vue&type=script&lang=js&"
export * from "./IframeResize.vue?vue&type=script&lang=js&"
import style0 from "./IframeResize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports